module.exports = __webpack_public_path__ + "media/site/images/icons/integration-icon-20590b685f6183f6d914cd72d40c7ca9.svg";